var _path, _path2, _path3, _circle, _rect, _path4, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path5, _path6, _path7, _path8, _path9, _path10, _rect2, _path11, _path12, _rect3, _path13, _path14, _path15, _path16, _path17, _path18, _circle9, _path19, _circle10, _circle11, _circle12, _circle13, _circle14, _path20, _path21, _path22, _path23, _path24, _path25, _circle15, _path26, _path27, _path28, _path29, _path30, _path31, _circle16, _path32, _path33, _path34, _path35, _path36, _path37, _circle17, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenseExpirationSpring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 504,
    height: 315,
    viewBox: "0 0 504 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.824 256.985L386.008 243.157L386.974 246.63L370.99 260.577L366.824 256.985Z",
    fill: "#DADEEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M375.753 250.408C374.722 243.536 360.359 240.592 353.09 243.69L352.128 263.087C359.617 271.078 369.213 281.736 375.516 264.813C380.193 252.257 369.428 256.683 364.39 251.773C366.887 254.207 376.785 257.279 375.753 250.408Z",
    fill: "#B2D1C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M353.09 243.69L352.091 243.64L352.122 243.015L352.698 242.77L353.09 243.69ZM375.753 250.408L374.764 250.556L375.753 250.408ZM363.692 252.489C363.296 252.104 363.288 251.471 363.674 251.075C364.059 250.68 364.692 250.672 365.088 251.057L363.692 252.489ZM375.516 264.813L374.579 264.464L375.516 264.813ZM352.128 263.087L351.398 263.771L351.108 263.461L351.129 263.037L352.128 263.087ZM352.698 242.77C356.598 241.107 362.247 241.099 367.013 242.343C369.411 242.968 371.659 243.929 373.396 245.221C375.133 246.513 376.432 248.196 376.742 250.259L374.764 250.556C374.558 249.184 373.676 247.922 372.202 246.826C370.729 245.73 368.739 244.86 366.508 244.278C362.018 243.106 356.851 243.174 353.482 244.61L352.698 242.77ZM376.742 250.259C377.034 252.206 376.575 253.719 375.379 254.651C374.264 255.519 372.738 255.691 371.315 255.577C369.859 255.46 368.316 255.029 366.981 254.477C365.662 253.931 364.445 253.223 363.692 252.489L365.088 251.057C365.583 251.54 366.54 252.129 367.746 252.629C368.937 253.122 370.273 253.486 371.475 253.583C372.709 253.682 373.62 253.485 374.15 253.073C374.597 252.724 374.988 252.045 374.764 250.556L376.742 250.259ZM365.088 251.057C366.168 252.109 367.591 252.697 369.187 253.155C369.99 253.385 370.783 253.569 371.603 253.777C372.403 253.979 373.215 254.201 373.962 254.495C375.471 255.089 376.861 256.037 377.417 257.88C377.944 259.63 377.643 261.968 376.453 265.162L374.579 264.464C375.728 261.38 375.835 259.562 375.502 258.457C375.197 257.445 374.458 256.839 373.23 256.356C372.609 256.112 371.901 255.915 371.112 255.716C370.343 255.521 369.478 255.319 368.636 255.078C366.943 254.592 365.131 253.892 363.692 252.489L365.088 251.057ZM376.453 265.162C374.848 269.472 372.97 272.214 370.807 273.641C368.576 275.113 366.202 275.087 363.915 274.229C361.675 273.388 359.463 271.733 357.384 269.849C355.296 267.957 353.261 265.758 351.398 263.771L352.858 262.403C354.74 264.411 356.713 266.541 358.727 268.366C360.75 270.2 362.736 271.65 364.618 272.357C366.455 273.046 368.13 273.011 369.705 271.972C371.348 270.888 373.033 268.616 374.579 264.464L376.453 265.162ZM351.129 263.037L352.091 243.64L354.089 243.739L353.127 263.136L351.129 263.037ZM364.961 265.027C364.479 264.371 364.212 263.472 364.102 262.54C363.99 261.588 364.029 260.506 364.238 259.409C364.652 257.23 365.765 254.854 367.877 253.318L369.053 254.935C367.468 256.088 366.552 257.943 366.202 259.783C366.029 260.696 366.002 261.572 366.089 262.305C366.178 263.059 366.376 263.575 366.572 263.843L364.961 265.027Z",
    fill: "#56957F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 267.5,
    cy: 218.5,
    r: 77.5,
    fill: "#F1F3F9",
    stroke: "#DADEEB",
    strokeWidth: 2.32335
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 182.791,
    y: 154.817,
    width: 168.443,
    height: 115.006,
    rx: 2.32335,
    fill: "white",
    stroke: "#DADEEB",
    strokeWidth: 2.32335
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.791 157.141C182.791 155.858 183.831 154.817 185.114 154.817H348.91C350.193 154.817 351.234 155.858 351.234 157.141V167.596H182.791V157.141Z",
    fill: "#F1F3F9",
    stroke: "#DADEEB",
    strokeWidth: 2.32335
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 289.407,
    cy: 198.38,
    r: 2.90419,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.779,
    cy: 198.38,
    r: 2.90419,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.599,
    cy: 201.865,
    r: 1.74251,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.97,
    cy: 200.704,
    r: 1.74251,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.246,
    cy: 204.769,
    r: 2.32335,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.455,
    cy: 204.769,
    r: 2.32335,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.617,
    cy: 76.6168,
    r: 11.6168,
    fill: "#F1F3F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195 149C218.5 155.833 270 169.3 288 168.5C306 167.7 324.167 154.167 331 147.5",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M298.5 108L324.5 148.5C318 155 304.5 164.5 285 164.5C274.134 164.5 225.833 153 204.5 146.5C208.833 139.667 218.8 124.6 224 107C247.2 97.8001 283.333 103.833 298.5 108Z",
    fill: "#8DB8AA",
    stroke: "#56957F",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M200.5 227C199.7 240.6 188.5 241.333 183 238.5V301H351.5C351.333 284.167 351.1 249 351.5 243C345.9 243 344.833 232.333 345 227H338.5C338.667 237.333 325.9 258 273.5 258C221.1 258 207.333 237.333 207 227H200.5Z",
    fill: "#F1F3F9",
    stroke: "#DADEEB",
    strokeWidth: 2.32335
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M299.38 206.458C289.506 212.94 276.147 212.359 265.692 206.458",
    stroke: "#9FA8BA",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M266.853 192.293C266.853 197.426 262.693 201.587 257.56 201.587C252.427 201.587 248.267 197.426 248.267 192.293C248.267 187.161 252.427 183 257.56 183C262.693 183 266.853 187.161 266.853 192.293Z",
    fill: "#9FA8BA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M263 192.347C263 195.385 260.538 197.847 257.5 197.847C254.463 197.847 252 195.385 252 192.347C252 189.31 254.463 186.847 257.5 186.847C260.538 186.847 263 189.31 263 192.347Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 191.847,
    width: 21,
    height: 11,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M314.853 192.293C314.853 197.426 310.693 201.587 305.56 201.587C300.427 201.587 296.266 197.426 296.266 192.293C296.266 187.161 300.427 183 305.56 183C310.693 183 314.853 187.161 314.853 192.293Z",
    fill: "#9FA8BA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M311 192.347C311 195.385 308.538 197.847 305.5 197.847C302.462 197.847 300 195.385 300 192.347C300 189.31 302.462 186.847 305.5 186.847C308.538 186.847 311 189.31 311 192.347Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 295,
    y: 191.847,
    width: 21,
    height: 11,
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M226.382 247.177C225.059 249.297 219.486 251.359 219.486 251.359C219.486 251.359 218.886 245.447 220.209 243.327C221.531 241.207 223.985 240.351 225.689 241.414C227.394 242.477 227.704 245.057 226.382 247.177Z",
    fill: "#78AB9A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M212.467 255.463C213.789 253.343 219.362 251.281 219.362 251.281C219.362 251.281 219.962 257.193 218.64 259.313C217.317 261.433 214.864 262.29 213.159 261.227C211.455 260.164 211.145 257.583 212.467 255.463Z",
    fill: "#78AB9A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M226.491 255.274C223.994 255.189 219.422 251.393 219.422 251.393C219.422 251.393 224.242 247.918 226.739 248.003C229.236 248.088 231.205 249.785 231.136 251.793C231.068 253.8 228.988 255.359 226.491 255.274Z",
    fill: "#78AB9A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M212.358 247.366C214.855 247.451 219.427 251.247 219.427 251.247C219.427 251.247 214.607 254.722 212.11 254.637C209.613 254.552 207.644 252.856 207.712 250.848C207.781 248.84 209.86 247.281 212.358 247.366Z",
    fill: "#78AB9A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M219.899 259.404C218.626 257.254 219.361 251.358 219.361 251.358C219.361 251.358 224.886 253.547 226.159 255.696C227.432 257.846 227.063 260.419 225.335 261.442C223.606 262.466 221.173 261.554 219.899 259.404Z",
    fill: "#78AB9A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M218.949 243.237C220.222 245.386 219.487 251.283 219.487 251.283C219.487 251.283 213.963 249.094 212.69 246.944C211.416 244.795 211.785 242.222 213.514 241.198C215.242 240.174 217.676 241.087 218.949 243.237Z",
    fill: "#78AB9A"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.486,
    cy: 251.359,
    r: 3.6376,
    transform: "rotate(31.952 219.486 251.359)",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M188.039 153.323V153.323C185.327 153.162 183.039 155.318 183.039 158.034V190.526C166.539 190.526 146.494 180.464 155.039 160.526C161.039 146.526 185.539 150.526 260.039 169.026C334.539 187.526 336.539 122.526 378.539 124.026C420.539 125.526 406.539 183.026 353.039 192.026V157.526C353.039 155.869 351.696 154.526 350.039 154.526H330.539",
    stroke: "#56957F",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 439.617,
    cy: 221.617,
    r: 11.6168,
    fill: "#F1F3F8"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.617,
    cy: 11.6168,
    r: 11.6168,
    fill: "#F1F3F8"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.5,
    cy: 83.5,
    r: 4.5,
    fill: "#F1F3F8"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.5,
    cy: 62.5,
    r: 4.5,
    fill: "#F1F3F8"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5001,
    cy: 203.5,
    r: 4.5,
    fill: "#F1F3F8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M405.516 231.232C403.373 234.668 394.339 238.01 394.339 238.01C394.339 238.01 393.366 228.427 395.51 224.991C397.653 221.554 401.63 220.166 404.394 221.889C407.157 223.612 407.659 227.795 405.516 231.232Z",
    fill: "#D0E7DF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M382.96 244.663C385.103 241.227 394.137 237.885 394.137 237.885C394.137 237.885 395.109 247.468 392.966 250.904C390.823 254.341 386.845 255.729 384.082 254.006C381.319 252.283 380.816 248.1 382.96 244.663Z",
    fill: "#D0E7DF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M405.693 244.357C401.645 244.219 394.234 238.066 394.234 238.066C394.234 238.066 402.047 232.432 406.095 232.57C410.142 232.708 413.334 235.459 413.223 238.713C413.112 241.968 409.741 244.495 405.693 244.357Z",
    fill: "#D0E7DF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M382.783 231.538C386.831 231.676 394.242 237.829 394.242 237.829C394.242 237.829 386.429 243.463 382.381 243.325C378.333 243.187 375.142 240.436 375.253 237.182C375.364 233.927 378.735 231.4 382.783 231.538Z",
    fill: "#D0E7DF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M395.008 251.051C392.944 247.566 394.136 238.008 394.136 238.008C394.136 238.008 403.091 241.556 405.155 245.041C407.219 248.526 406.62 252.696 403.818 254.356C401.017 256.015 397.072 254.536 395.008 251.051Z",
    fill: "#D0E7DF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M393.468 224.844C395.532 228.329 394.34 237.887 394.34 237.887C394.34 237.887 385.385 234.339 383.321 230.854C381.257 227.369 381.855 223.199 384.657 221.54C387.459 219.88 391.404 221.359 393.468 224.844Z",
    fill: "#D0E7DF"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.338,
    cy: 238.01,
    r: 5.89655,
    transform: "rotate(31.952 394.338 238.01)",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5422 284.333C96.5422 288.383 90.6457 296 90.6457 296C90.6457 296 84.7491 288.383 84.7491 284.333C84.7491 280.283 87.3891 277 90.6457 277C93.9023 277 96.5422 280.283 96.5422 284.333Z",
    fill: "#F1F3F8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5117 307.667C84.5117 303.617 90.4083 296 90.4083 296C90.4083 296 96.3048 303.617 96.3048 307.667C96.3048 311.717 93.6648 315 90.4083 315C87.1517 315 84.5117 311.717 84.5117 307.667Z",
    fill: "#F1F3F8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M103.638 295.376C100.131 297.401 90.5863 296.103 90.5863 296.103C90.5863 296.103 94.2342 287.188 97.7417 285.163C101.249 283.138 105.413 283.783 107.041 286.603C108.669 289.423 107.146 293.351 103.638 295.376Z",
    fill: "#F1F3F8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4157 296.624C80.9232 294.599 90.4676 295.897 90.4676 295.897C90.4676 295.897 86.8198 304.812 83.3123 306.837C79.8048 308.862 75.6414 308.217 74.0132 305.397C72.3849 302.577 73.9082 298.649 77.4157 296.624Z",
    fill: "#F1F3F8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1149 306.711C94.5194 304.846 90.4723 296.105 90.4723 296.105C90.4723 296.105 99.9483 294.377 103.544 296.241C107.139 298.106 108.839 301.961 107.339 304.852C105.84 307.743 101.71 308.575 98.1149 306.711Z",
    fill: "#F1F3F8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9391 285.289C86.5345 287.154 90.5816 295.895 90.5816 295.895C90.5816 295.895 81.1057 297.623 77.5102 295.759C73.9148 293.894 72.2154 290.039 73.7145 287.148C75.2137 284.257 79.3436 283.425 82.9391 285.289Z",
    fill: "#F1F3F8"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.6457,
    cy: 296,
    r: 5.89655,
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5422 66.3333C61.5422 70.3834 55.6457 78 55.6457 78C55.6457 78 49.7491 70.3834 49.7491 66.3333C49.7491 62.2832 52.3891 59 55.6457 59C58.9023 59 61.5422 62.2832 61.5422 66.3333Z",
    fill: "#DADEEB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5117 89.6667C49.5117 85.6166 55.4083 78 55.4083 78C55.4083 78 61.3048 85.6166 61.3048 89.6667C61.3048 93.7168 58.6648 97 55.4083 97C52.1517 97 49.5117 93.7168 49.5117 89.6667Z",
    fill: "#DADEEB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6382 77.376C65.1307 79.4011 55.5863 78.1028 55.5863 78.1028C55.5863 78.1028 59.2342 69.1879 62.7417 67.1629C66.2492 65.1378 70.4125 65.7825 72.0408 68.6028C73.6691 71.4231 72.1457 75.351 68.6382 77.376Z",
    fill: "#DADEEB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4157 78.624C45.9232 76.5989 55.4676 77.8972 55.4676 77.8972C55.4676 77.8972 51.8198 86.8121 48.3123 88.8371C44.8048 90.8622 40.6414 90.2175 39.0132 87.3972C37.3849 84.5769 38.9082 80.649 42.4157 78.624Z",
    fill: "#DADEEB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1149 88.7106C59.5194 86.8462 55.4723 78.1053 55.4723 78.1053C55.4723 78.1053 64.9483 76.3769 68.5437 78.2414C72.1392 80.1058 73.8385 83.9608 72.3394 86.8518C70.8403 89.7428 66.7103 90.575 63.1149 88.7106Z",
    fill: "#DADEEB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9391 67.2894C51.5345 69.1538 55.5816 77.8947 55.5816 77.8947C55.5816 77.8947 46.1057 79.6231 42.5102 77.7586C38.9148 75.8942 37.2154 72.0392 38.7145 69.1482C40.2137 66.2572 44.3436 65.425 47.9391 67.2894Z",
    fill: "#DADEEB"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.6457,
    cy: 77.9999,
    r: 5.89655,
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M450.035 71.3852L450.281 92.6972L431.362 81.4941C427.256 79.0624 424.976 74.4324 425.552 69.6948C426.475 62.1048 434.154 57.2922 441.388 59.7705L441.718 59.8835C446.644 61.5716 449.975 66.1777 450.035 71.3852Z",
    stroke: "#DADEEB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M437.353 101.228L449.2 94.569L436.982 87.6936C434.33 86.2012 431.046 86.4184 428.614 88.2471C424.716 91.1768 424.507 96.9517 428.182 100.156L428.349 100.302C430.852 102.484 434.458 102.855 437.353 101.228Z",
    stroke: "#DADEEB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M442.103 106.234L457.853 78.9545L464.978 66.6136C466.29 64.3417 465.512 61.4367 463.24 60.125V60.125C460.968 58.8133 458.063 59.5917 456.751 61.8636L455.126 64.6782",
    stroke: "#DADEEB",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M442.536 106.484L458.286 79.2045L465.411 66.8636C466.723 64.5917 469.628 63.8133 471.9 65.125V65.125C474.172 66.4367 474.95 69.3417 473.639 71.6136L472.014 74.4282",
    stroke: "#DADEEB",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M469.455 82.5973L450.875 93.0406L470.037 103.823C474.196 106.163 479.346 105.823 483.16 102.955C489.272 98.3605 489.6 89.3039 483.837 84.2789L483.575 84.0498C479.649 80.6272 473.995 80.0455 469.455 82.5973Z",
    stroke: "#DADEEB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M449.951 108.502L449.795 94.9124L461.858 102.056C464.477 103.607 465.93 106.559 465.563 109.58C464.974 114.42 460.078 117.489 455.466 115.908L455.255 115.836C452.114 114.76 449.99 111.823 449.951 108.502Z",
    stroke: "#DADEEB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9842 192.877L30.8432 205.117L41.7086 198.683C44.0671 197.286 45.3764 194.627 45.0455 191.906C44.5153 187.547 40.105 184.783 35.9508 186.206L35.7613 186.271C32.9318 187.241 31.0187 189.886 30.9842 192.877Z",
    stroke: "#F1F3F8",
    strokeWidth: 2.87164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2681 210.017L31.4639 206.192L38.4812 202.243C40.0044 201.386 41.8903 201.511 43.2874 202.561C45.5256 204.244 45.6458 207.56 43.5353 209.401L43.4391 209.485C42.0015 210.738 39.9307 210.951 38.2681 210.017Z",
    stroke: "#F1F3F8",
    strokeWidth: 2.87164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5396 212.892L26.4939 197.224L22.4018 190.136C21.6485 188.831 22.0956 187.163 23.4004 186.41V186.41C24.7052 185.656 26.3736 186.103 27.127 187.408L28.0603 189.025",
    stroke: "#F1F3F8",
    strokeWidth: 2.87165,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2909 213.035L26.2452 197.368L22.1531 190.28C21.3998 188.975 19.7313 188.528 18.4265 189.281V189.281C17.1217 190.035 16.6747 191.703 17.428 193.008L18.3613 194.624",
    stroke: "#F1F3F8",
    strokeWidth: 2.87165,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8308 199.316L30.5015 205.314L19.4966 211.507C17.1079 212.851 14.1503 212.655 11.9594 211.008C8.44934 208.369 8.26079 203.168 11.5706 200.282L11.7215 200.15C13.9759 198.185 17.2235 197.851 19.8308 199.316Z",
    stroke: "#F1F3F8",
    strokeWidth: 2.87164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0324 214.194L31.1223 206.389L24.1939 210.492C22.69 211.383 21.8551 213.078 22.0661 214.813C22.4042 217.593 25.2165 219.355 27.8654 218.448L27.9862 218.406C29.7905 217.788 31.0104 216.101 31.0324 214.194Z",
    stroke: "#F1F3F8",
    strokeWidth: 2.87164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseExpirationSpring);
export default __webpack_public_path__ + "static/media/license_expiration_spring.cb39203f71367dce5e6fe5fcd0d7fa67.svg";
export { ForwardRef as ReactComponent };